import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AdminTabsLayout } from "src/components/AdminTabsLayout";

export const Route = createFileRoute("/_auth/_admin/admin/billing")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        label: "Billing",
        href: "/admin/billing",
      };
    },
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <AdminTabsLayout
      label="Billing sections"
      tabs={[
        {
          to: "/admin/billing",
          label: t("adminBilling.tabs.plans"),
          exact: true,
        },
        {
          to: "/admin/billing/features",
          label: t("adminBilling.tabs.features"),
        },
        { to: "/admin/billing/actions", label: t("adminBilling.tabs.actions") },
      ]}
    />
  );
}
